var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.99997 1V12.17L2.11997 7.29C1.72997 6.9 1.08997 6.9 0.699971 7.29C0.309971 7.68 0.309971 8.31 0.699971 8.7L7.28997 15.29C7.67997 15.68 8.30997 15.68 8.69997 15.29L15.29 8.7C15.68 8.31 15.68 7.68 15.29 7.29C14.9 6.9 14.27 6.9 13.88 7.29L8.99997 12.17V1C8.99997 0.45 8.54997 0 7.99997 0C7.44997 0 6.99997 0.45 6.99997 1Z","fill":"#334155"}));
}

Icon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
